'use strict';

var JQXTreeNodeCustomColumnFactory = function JQXTreeNodeCustomColumnFactory(NodeColumn) {
  function CustomColumnNode(params) {
    NodeColumn.call(this, params);
    this.custom = true;
    this.formula = params.formula;
    this.addFaIcon('fa-user');
  }
  CustomColumnNode.prototype = Object.create(NodeColumn.prototype);
  CustomColumnNode.prototype.constructor = CustomColumnNode;
  return CustomColumnNode;
};
JQXTreeNodeCustomColumnFactory.$inject = ['JQXTreeNodeColumnFactory'];
module.exports = JQXTreeNodeCustomColumnFactory;